export interface bookType {
	id: string;
	userId?: string;
	index: number;
	author: string;
	title: string;
	category: Array<string>;
	readingMedium: string;
	yearRead: number;
	lastReadAt?: string | null;
	updatedAt?: string;
	status: string;
}

export type bookStatusType = 'reading' | 'want to read' | 'read';

export const books: bookType[] = [
	{
		id: 'fabzarhp1uguccf8hshc',
		index: 1,
		author: 'Ashlee Vance',
		title: 'Elon Musk’s biography',
		category: ['biography'],
		readingMedium: 'audio',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'dkmy5uvp6xnet8g0hwgk',
		index: 2,
		author: 'Corey Wayne',
		title: 'How to Be a 3% Man',
		category: ['self help', 'relationships', 'psychology', 'sexuality'],
		readingMedium: 'e-book',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 's6o4v2cnp2xflqip124n',
		index: 3,
		author: 'Carl Sagan',
		title: 'Pale Blue Dot',
		category: ['science', 'astronomy', 'space', 'physics'],
		readingMedium: 'paper',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'gi6qispntbhqpsdo65as',
		index: 4,
		author: 'Derek Sivers',
		title: 'Anything You Want',
		category: ['business', 'entrepreneurship', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'keebf0pg6qcj284yfh69',
		index: 5,
		author: 'Carl Sagan',
		title: 'Cosmos',
		category: ['science', 'astronomy', 'space', 'physics'],
		readingMedium: 'paper',
		yearRead: 2019,
		lastReadAt: '2023-06-26T10:22:26Z',
		updatedAt: '2023-06-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'a5sjqkntod0kft06nrq0',
		index: 6,
		author: 'Tony Robbins',
		title: 'Personal Power 2',
		category: ['self help', 'personal development', 'psychology'],
		readingMedium: 'audio',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'g5dl1zz3h06wv2765ka0',
		index: 7,
		author: 'Robert C. Martin',
		title: 'The Robert C. Martin Clean Code Collection',
		category: ['programming', 'computer science', 'technology'],
		readingMedium: 'e-book',
		yearRead: 2019,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'r9844uiak7u30hdzys42',
		index: 8,
		author: 'Benjamin Graham',
		title: 'The Intelligent Investor',
		category: ['investing', 'finance', 'business', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '7qgfqwgwrpxknpyxfhdp',
		index: 9,
		author: 'Robert T. Kiyosaki',
		title: 'Rich Dad, Poor Dad',
		category: ['business', 'finance', 'self help', 'money'],
		readingMedium: 'e-book',
		yearRead: 2020,
		lastReadAt: '2023-03-26T10:22:26Z',
		updatedAt: '2023-03-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'zj7h0qbjatbuw9nyiwvo',
		index: 10,
		author: 'Simon Sinek',
		title: 'The Infinite Game',
		category: ['business', 'leadership', 'self help', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '9gr8i2upuicnas42tuhd',
		index: 11,
		author: 'Phillip A. Fisher',
		title: 'Common Stocks and Uncommon Profits',
		category: ['business', 'finance', 'economics'],
		readingMedium: 'paper',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '9k5wi8op4er6cwp3ecqa',
		index: 12,
		author: 'Cade Metz',
		title: 'Genius Makers',
		category: ['science', 'technology', 'artificial intelligence'],
		readingMedium: 'e-book',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'wzvm4na3y54ewoatbwre',
		index: 13,
		author: 'James Clear',
		title: 'Atomic Habits',
		category: ['self help', 'personal development', 'psychology', 'productivity'],
		readingMedium: 'paper',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '7nsf86hnl2l3v85e04o1',
		index: 14,
		author: 'Cal Newport',
		title: 'Deep Work',
		category: ['self help', 'personal development', 'psychology', 'productivity'],
		readingMedium: 'audio',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '37iyxbnnahyd143hy6h5',
		index: 15,
		author: 'Richard P. Feynman',
		title: "Surely You're Joking, Mr. Feynman!",
		category: ['science', 'biography', 'physics'],
		readingMedium: 'paper',
		yearRead: 2020,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'vhktjceu0f5szho2t6rw',
		index: 16,
		author: 'David Goggins',
		title: "Can't Hurt Me",
		category: ['self help', 'biography', 'psychology'],
		readingMedium: 'audio',
		yearRead: 2020,
		lastReadAt: '2023-05-26T10:22:26Z',
		updatedAt: '2023-05-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'mvck5hxh5zheb7brdssi',
		index: 17,
		author: 'Thomas J. Stanley',
		title: 'The Millionaire Next Door',
		category: ['business', 'finance', 'economics'],
		readingMedium: 'paper',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '6kpyragssilqyclu4mir',
		index: 18,
		author: 'George S. Clason',
		title: 'The Richest Man in Babylon',
		category: ['investing', 'money', 'self help'],
		readingMedium: 'e-book',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 's9kg82krhup7fqz7cpai',
		index: 19,
		author: 'Felix Dennis',
		title: 'How to Get Rich',
		category: ['business', 'finance', 'money'],
		readingMedium: 'paper',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'q2en9i9ahag47m2d09pi',
		index: 20,
		author: 'Napoleon Hill',
		title: 'Think and Grow Rich',
		category: ['self help', 'personal development', 'finance'],
		readingMedium: 'audio',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '4gi0ructntj1k65onwby',
		index: 21,
		author: 'Peter H. Diamandis',
		title: 'Abundance',
		category: ['science', 'technology', 'business'],
		readingMedium: 'paper',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'apwgncfec61af5peyw4o',
		index: 22,
		author: 'Dale Carnegie',
		title: 'How to Win Friends & Influence People',
		category: ['self help', 'personal development', 'business', 'psychology'],
		readingMedium: 'e-book',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'ruqivumpm3okoqhncquc',
		index: 23,
		author: 'Władysław Szpilman',
		title: 'The Pianist',
		category: ['history', 'biography', 'war'],
		readingMedium: 'e-book',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '2xc8ojy8e83hknh3qxgp',
		index: 24,
		author: 'Jon Kabat-Zinn',
		title: 'Wherever You Go, There You Are',
		category: ['self help', 'psychology', 'spirituality', 'philosophy'],
		readingMedium: 'audio',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'q57n3ownvlm3belm8vj1',
		index: 25,
		author: 'Florence Littauer',
		title: 'Personality Plus',
		category: ['self help', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2021,
		lastReadAt: '2023-04-26T10:22:26Z',
		updatedAt: '2023-04-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '4msc2cw8uos0wh0vm21h',
		index: 26,
		author: 'J.L. Collins',
		title: 'The Simple Path to Wealth',
		category: ['finance', 'business', 'self help', 'personal development'],
		readingMedium: 'audio',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'a98200esjmo5d2iczxdj',
		index: 27,
		author: 'Josh Kaufman',
		title: 'The Personal MBA',
		category: ['business', 'entrepreneurship', 'finance', 'personal development'],
		readingMedium: 'audio',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'v30pqi7qvotokcmsez8e',
		index: 28,
		author: 'Stephen R. Covey',
		title: 'The 7 Habits of Highly Effective People',
		category: ['self help', 'business', 'psychology', 'productivity'],
		readingMedium: 'audio',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'yk5u2ld3bcgnf5evnebu',
		index: 29,
		author: 'Dan Harris',
		title: '10% Happier',
		category: ['self help', 'psychology', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'l5wdseatpsswu20v0h56',
		index: 30,
		author: 'Sun Tzu',
		title: 'The Art of War',
		category: ['philosophy', 'history', 'war', 'politics'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'v4iyl7p35ponniwjltt7',
		index: 31,
		author: 'Gary Vaynerchuk',
		title: 'Crush It!',
		category: ['business', 'self help', 'entrepreneurship'],
		readingMedium: 'e-book',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'xpatl13xb1wm0yic5hwu',
		index: 32,
		author: 'Brian Tracy',
		title: 'Goals!',
		category: ['self help', 'business', 'productivity'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'so623nozgh5cox2a9fff',
		index: 33,
		author: '50 Cent',
		title: 'Hustle Harder, Hustle Smarter',
		category: ['business', 'biography', 'self help'],
		readingMedium: 'paper',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '1qqf3epbc12evpq92nbb',
		index: 34,
		author: 'Peter Thiel',
		title: 'Zero to One',
		category: ['business', 'entrepreneurship', 'self help'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 's1t5f9pkyzfxwrk03ke2',
		index: 35,
		author: 'Tom Hopkins',
		title: 'The Official Guide To Success',
		category: ['self help', 'business'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'qonb81oy3mx4vqp2ho57',
		index: 36,
		author: 'Morgan Housel',
		title: 'The Psychology of Money',
		category: ['finance', 'psychology', 'business'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '2s9ouha68lauh3aaas4x',
		index: 37,
		author: 'Eric Berger',
		title: 'Liftoff',
		category: ['biography', 'space', 'science', 'technology'],
		readingMedium: 'paper',
		yearRead: 2021,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '6apu5jj9pefwei732raw',
		index: 38,
		author: 'Peter Lynch',
		title: 'One Up On Wall Street',
		category: ['business', 'finance', 'economics'],
		readingMedium: 'e-book',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'o0hfu20lx1o31fd4n8lp',
		index: 39,
		author: 'Daniel Pecaut',
		title: 'University of Berkshire Hathaway',
		category: ['business', 'finance', 'economics'],
		readingMedium: 'e-book',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '6okp2oepxq92wqm0q3kw',
		index: 40,
		author: 'Richard P. Feynman',
		title: 'What Do You Care What Other People Think?',
		category: ['science', 'biography', 'physics'],
		readingMedium: 'paper',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'kkwl7jph1pw8ney7pdxu',
		index: 41,
		author: 'David Allen',
		title: 'Getting Things Done',
		category: ['business', 'productivity', 'self help'],
		readingMedium: 'paper',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'vhwp5uiewsfmwym39s9u',
		index: 42,
		author: 'Al Sweigart',
		title: 'The Big Book of Small Python Projects',
		category: ['programming', 'computer science', 'technology'],
		readingMedium: 'e-book',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 's7ov0usn0xma5llj77bk',
		index: 43,
		author: 'Ben Horowitz',
		title: 'The Hard Thing About Hard Things',
		category: ['business', 'entrepreneurship', 'management'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'fp6qsxe3ivada383wllw',
		index: 44,
		author: 'Laura Hillenbrand',
		title: 'Unbroken',
		category: ['history', 'biography', 'war'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '8eelx7md8mvijn8o15t0',
		index: 45,
		author: 'Malcolm Gladwell',
		title: 'Outliers',
		category: ['business', 'psychology', 'self help'],
		readingMedium: 'audio',
		yearRead: 2022,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '7gg9ssbvx8vexlbinhkr',
		index: 46,
		author: 'Orison Swett Marden',
		title: 'Pushing to the Front or Success Under Difficulties',
		category: ['self help', 'business', 'leadership'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'o0siy986h384owewqu4f',
		index: 47,
		author: 'Viktor E. Frankl',
		title: "Man's Search for Meaning",
		category: ['psychology', 'philosophy', 'history'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '2m5qwwzn3v85fp2po3py',
		index: 48,
		author: 'Robert B. Cialdini',
		title: 'Influence',
		category: ['psychology', 'business', 'self help'],
		readingMedium: 'e-book',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'ti5gviuqcq1nkbpz0oje',
		index: 49,
		author: 'Tony Robbins',
		title: 'Life Force',
		category: ['health', 'longevity', 'personal development'],
		readingMedium: 'e-book',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: '1z12yynagyfyb9bgwggd',
		index: 50,
		author: 'Eric Ries',
		title: 'The Lean Startup',
		category: ['business', 'entrepreneurship', 'management'],
		readingMedium: 'paper',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'read',
	},
	{
		id: 'kvmy5ece231lv1j1viai',
		index: 51,
		author: 'Darren Hardy',
		title: 'The Entrepreneur Roller Coaster',
		category: ['business', 'entrepreneurship', 'self help'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'reading',
	},
	{
		id: '5qejk1qlr854gk1yvo7z',
		index: 52,
		author: 'Jon Krakauer',
		title: 'Into the Wild',
		category: ['biography', 'travel', 'adventure'],
		readingMedium: 'e-book',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'reading',
	},
	{
		id: 'yrvazcyayyg70eau60cx',
		index: 53,
		author: 'Nick Lane',
		title: 'The Vital Question',
		category: ['science', 'biology', 'evolution'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'reading',
	},
	{
		id: 'hffex87cea0w2gc8k7zr',
		index: 54,
		author: 'Nick Lane',
		title: 'Life Ascending',
		category: ['science', 'biology', 'evolution'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: 'l5daol1x9tiw3peq9hoy',
		index: 55,
		author: 'Ray Kurzweil',
		title: 'The Singularity is Near',
		category: ['science', 'technology', 'artificial intelligence'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: '0tobdpptitqvtqwrycwb',
		index: 56,
		author: 'Cameron R. Hanes',
		title: 'Endure',
		category: ['self help', 'biography'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: '4a8rntwkytc5kk5styfu',
		index: 57,
		author: 'Brian Tracy',
		title: 'Kiss That Frog!',
		category: ['self help', 'personal development', 'business'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: 'f4axwxjlqudds966oh1p',
		index: 58,
		author: 'Matthew Walker',
		title: 'Why We Sleep',
		category: ['science', 'health', 'psychology'],
		readingMedium: 'paper',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: 'f99ey5110rgnffb69mt7',
		index: 59,
		author: 'Robin S. Sharma',
		title: 'The 5 AM Club',
		category: ['self help', 'personal development', 'productivity'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
	{
		id: 'bkawk37wiudwydyn8r5m',
		index: 60,
		author: 'Rolf Potts',
		title: 'Vagabonding',
		category: ['travel', 'philosophy', 'adventure'],
		readingMedium: 'audio',
		yearRead: 2023,
		lastReadAt: '2023-02-26T10:22:26Z',
		updatedAt: '2023-02-26T10:22:26Z',
		status: 'want to read',
	},
];
